import dayjs from "dayjs";
import { ObjectId } from "mongoose";

export interface IPartTypeSQL {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
}

export interface IResponse<T> {
  status: number;
  message?: string;
  errors?: string[];
  data: T;
}

export interface IItem {
  _id: any;
  name: string;
  description: string;
  brandId: string;
  partTypeId: string[];
  officialUrl?: string;
  officialPrice?: number;
  imageUrl?: string;
  expired?: boolean;
  variants?: IVariant[];
  priceMin?: number;
  priceMax?: number;
}

export interface IProduct {
  _id: string;
  name: string;
  description?: string;
  brandId: string;
  partTypeId: string[];
  officialUrl?: string;
  imageUrl?: string;
  variant?: IVariant;
  price: number;
}

export interface ICharacteristic {
  id: number;
  name: string;
  value: string;
  numericValue: number;
  description: string;
}

export interface IItemLink {
  id: number;
  url: string;
  description: string;
  price: number;
  currency: string;
}

export interface ISupplierSection {
  id: number;
  supplierId: number;
  name: string;
  partTypeId: number;
  url: string;
}

export interface ISupplier {
  id: number;
  name: string;
  website: string;
  sections: ISupplierSection[];
}

export interface IVariant {
  url: string;
  price: number;
  delivery: number;
  fastDelivery: number;
  qty: number;
  hasDiscounts: number;
  sellerId?: string;
  marketplaceId?: string;
}

export interface IBrand {
  _id: string;
  name: string;
  description: string;
  siteUrl: string;
  logoUrl: string;
  itemsCount?: number;
}

export interface IStoreItem {
  _id: string;
  itemId: string;
  brandId: string;
  partTypeId: string;
  price: number;
  deliveryCost: number;
  status: number;
  storeId: number;
  storePlaceId: number;
  url: string;
  quantity: number;
  orderUrl: string;
  orderId: string;
  orderDate: Date | dayjs.Dayjs;
  realItem?: IItem;
}

export interface ISelectOption {
  value: number;
  label: string;
}

export interface IDroneRecord {
  id: number;
  frame: number;
  motor: number;
  flightControllerStack: number;
  vtx: number;
  camera: number;
  vtxAntena: number;
  propellers: number;
  antenaConnector: number;
  battery: number;
  batteryStrap: number;
  otherComponents: Record<string, number>;
}

export interface IComment {
  _id?: string;
  text: string;
  author?: string;
  createdAt?: Date;
}

export enum EMainDroneParts {
  frame = 'Frame',
  motors = 'Motor',
  camera = 'camera',
  fcStack1 = 'FC Stack',
  fcStack = 'fcStack',
  // fcStack = 'fcSingle',
  fcSingle = 'Flight controller',
  esc = 'ESC',
  vtx = 'vtx',
  antenna = 'vtxAntenna',
  // antennaConnector = 'vtxAntennaConnector',
  receiver = 'receiver',
  // propellers = 'propellers',
  // battery = 'Battery',
}


export enum EPartType {
  frame = 'Frame',
  frame7 = 'Frame 7inch',
  frame7rs = 'Frame 7inch RS',
  frame7small = 'Frame 7inch (small)',
  frame7Big = 'Frame 7inch (big)',
  frame8 = 'Frame 8inch',
  frame9 = 'Frame 9inch',
  frame10 = 'Frame 10inch',
  frame10more = 'Frame >10inch',
  fcStack = 'fcSingle',
  fcStack45A = 'FC Stack 45A',
  fcStack50A = 'FC Stack 50A',
  fcStack55A = 'FC Stack 55A',
  fcStack60A = 'FC Stack 60A',
  fcSingle = 'Flight controller',
  esc = 'esc',
  esc45A = 'ESC 45A',
  esc50A = 'ESC 50A',
  esc55A = 'ESC 55A',
  esc60A = 'ESC 60A',
  pdb = 'PDB',
  condensator = 'Condensator',
  condensatorN = 'Condensator 1000mkF',
  condensatorB = 'Condensator 1500mkF',
  dampers = 'Damper',
  nuts = 'Nut',
  motors = 'Motor',
  motors28 = 'Motor 2807/2808/2806.5',
  motors2812 = 'Motor 2812',
  motors25 = 'Motor 25XX',
  motors31 = 'Motor 31XX',
  screws = 'Screws',
  propellers = 'Propellers',
  propellers7 = 'Propellers 7inch',
  propellers8 = 'Propellers 8inch',
  propellers9 = 'Propellers 9inch',
  propellers10 = 'Propellers 10inch',
  camera = 'Camera',
  cameraSimple = 'Camera simple',
  cameraEvening = 'Camera evening',
  cameraNightIR = 'Camera Night/IR',
  cameraThermal = 'Camera Thermal',
  cameraZoom = 'Camera Zoom',
  cameraSwitcher = 'Camera Switcher',
  vtx = 'VTX',
  vtxSmall = 'VTX small size',
  vtxMiddle = 'VTX middle size',
  vtxBig = 'VTX big size',
  vtxAntenna = 'vtxAntenna',
  mounts = 'Mounts',
  sponges = 'Sponge',
  antenna = 'Antenna',
  antennaElrs = 'Antenna For ELRS',
  antennaConnector = 'Antenna connector',
  receiver = 'Receiver',
  receiverSimple = 'Receiver simple',
  receiverDiversity = 'Receiver diversity',
  receiverCrossfire = 'Crossfire',
  receiver24 = 'Receiver 2.4Ghz',
  gps = 'GPS',
  buzzer = 'Buzzer',
  led = 'Led',
  cable = 'Cable',
  cablePower = 'Cable AWG 12',
  cableSleeve = 'Cable sleeve',
  xt60ConnectorF = 'Amas xt60-f',
  xt60ConnectorM = 'Amas XT-60h-m',
  other = 'Other',
  battery = 'battery',
  accumulators = 'Accumulators',
  nickelStrip = 'Nickel strip',
  balancingCable = 'Balancing cable',
  strongAdhesiveTape = 'Fiber glass adhesive tape',
  adhesiveTape = 'adhesive tape',
  captonTape = 'Capton tape',
  carton = 'Carton',
  hotGlue = 'Hot glue',
  cartonRings = 'Battery Insulation Gasket',
  heatShrink = 'Heat shrink',
  batteryStrap = 'Battery strap',
  screwdriverBits = 'Screwdriver Bits',
  nylonTie = 'Nylon tie',
}

export * from './lib/parts.interfaces';
export * from './lib/stock.interface';

export interface IBattery {
  _id: string;
  name?: string;
  status?: string;
  cellsCount: number;
  linesCount: number;
  capacity: number;
  voltage: number;
  price: number;
  currency: string;
  description?: string;
  parts: IBatteryPart[];
}

export interface IBatteryPart {
  key: string;
  name: string;
  itemId: string;
  quantity: number;
  price: number;
  total: number;
  currency: string;
}

export interface IPaginatedResponce<T> {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
  data: T[];
  toOrder?: any;
  dronesModels?: string[];
}

export interface ICurrencyRate {
  _id: string;
  date: string;
  baseCurrency: string;
  rates: Record<string, number>;
}

export interface IPaginatedQuery {
  page?: number;
  pageSize?: number;
  searchTerm?: string;
}

export interface ITranslatedText {
  en: string;
  uk: string;
}

export * from './lib/drone.interfaces';
export * from './lib/product-template.interface';
export * from './lib/user-permission.interface';
export * from './lib/v2/dto.interface';
export * from './lib/links.interface';
